import { create } from 'zustand';
import type { SessionUiState } from './sessionUiState';
import { createSessionUiSlice } from './slices/sessionUiSlice';

export const useSessionUiStore = create<SessionUiState>()((set) => ({
  ...createSessionUiSlice(set),
}));
